// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3X7aw","footer":"ChangeClinic_footer__3i7cz"};